import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogService } from './dialog.service';
import { RouterModule } from '@angular/router';
import { DeleteDialogComp } from './dialog';
import { MaterialModule } from '../../material';
import { UIElementModule } from '../../uielement';
import { MatButtonModule } from '@angular/material';




@NgModule({
	imports: [
		RouterModule,
		UIElementModule
	],
	declarations: [DeleteDialogComp, MatButtonModule],
	exports: [],
	entryComponents: [DeleteDialogComp],
	providers: [DialogService]
})
export class DialogModule { }
